"use strict";
/*
 * Created on 03 01 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractReleasePart_1 = require("../AbstractReleasePart");
/**
 * Sellout category release part. It indirectly encapsulates products that should be reprices within release.
 *
 * @author JMe
 * @author Radek Beran
 */


var SelloutReleasePart =
/*#__PURE__*/
function (_AbstractReleasePart_) {
  _inherits(SelloutReleasePart, _AbstractReleasePart_);

  /**
   * @param releaseId the internal id of release
   * @param productCategoryId category which represented
   * @param approved date of release part (category) approval if category of release part was finally approved
   * @param firstApproval The same as before. However, only the first date of approval is saved in case of subsequent release re-opening.
   * @param approvedByUserId ID of a user who approved the release part
   * @param approvedByUserName name of user who approved release part
   * @param cmDeadlineMissed true if CM approval was in delay - CM deadline was missed, higher role must approve the prices instead
   * @param workflowCaseId id of workflow instance if workflow is already initiated
   * @param calcWorkflowCaseId
   * @param calcProgressMonitorId
   * @param validationResult
   * @param readonly true if all items in this category cannot be edited, repriced and were not exported
   */
  function SelloutReleasePart(releaseId, productCategoryId, approved, firstApproval, approvedByUserId, approvedByUserName, cmDeadlineMissed, workflowCaseId, calcWorkflowCaseId, calcProgressMonitorId, validationResult, readonly) {
    var _this;

    _classCallCheck(this, SelloutReleasePart);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleasePart).call(this, releaseId, productCategoryId, approved, firstApproval, approvedByUserId, approvedByUserName, cmDeadlineMissed, workflowCaseId, calcWorkflowCaseId, calcProgressMonitorId, validationResult, readonly));
    _this.releaseId = releaseId;
    _this.productCategoryId = productCategoryId;
    _this.approved = approved;
    _this.firstApproval = firstApproval;
    _this.approvedByUserId = approvedByUserId;
    _this.approvedByUserName = approvedByUserName;
    _this.cmDeadlineMissed = cmDeadlineMissed;
    _this.workflowCaseId = workflowCaseId;
    _this.calcWorkflowCaseId = calcWorkflowCaseId;
    _this.calcProgressMonitorId = calcProgressMonitorId;
    _this.validationResult = validationResult;
    _this.readonly = readonly;
    return _this;
  }
  /**
   * Returns true if given release part is sellout release part.
   * Use this method rarely, only in meaningful cases.
   */


  _createClass(SelloutReleasePart, [{
    key: "withMessage",
    value: function withMessage(message) {
      return this.copy('validationResult', this.validationResult.addObject(message));
    }
  }], [{
    key: "isSelloutReleasePart",
    value: function isSelloutReleasePart(releasePart) {
      return releasePart instanceof SelloutReleasePart;
    }
  }]);

  return SelloutReleasePart;
}(AbstractReleasePart_1.AbstractReleasePart);

exports.SelloutReleasePart = SelloutReleasePart;
SelloutReleasePart.schema = AbstractReleasePart_1.AbstractReleasePart.schema;